import { render, staticRenderFns } from "./fireDetectionAlarmSystemInfo.vue?vue&type=template&id=6a0736c1"
import script from "./fireDetectionAlarmSystemInfo.vue?vue&type=script&lang=js"
export * from "./fireDetectionAlarmSystemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0736c1')) {
      api.createRecord('6a0736c1', component.options)
    } else {
      api.reload('6a0736c1', component.options)
    }
    module.hot.accept("./fireDetectionAlarmSystemInfo.vue?vue&type=template&id=6a0736c1", function () {
      api.rerender('6a0736c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/fdas/fireDetectionAlarmSystemInfo.vue"
export default component.exports